import BaseModel from "./BaseModel"

export default class ProgramPosition extends BaseModel {
  id: number
  title: string
  displayOrder: number
}